import { render, staticRenderFns } from "./storeCoverSetting.vue?vue&type=template&id=0f19b6f8&scoped=true"
import script from "./storeCoverSetting.vue?vue&type=script&lang=js"
export * from "./storeCoverSetting.vue?vue&type=script&lang=js"
import style0 from "./storeCoverSetting.vue?vue&type=style&index=0&id=0f19b6f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f19b6f8",
  null
  
)

export default component.exports